// src/pages/RecommendationProjectPage/RisksTab/RisksTab.tsx
import React from "react";
import { ClimateRisksCard } from "./ClimateRisksCard";
import { ProjectPermanenceCard } from "./ProjectPermanceCard";
import { NDCTargetsCard } from "./NDCTargetsCard";
import { useSelectedRecommendedProjectSelector } from "../../../store/projects/selectors";

const RisksTab = () => {
  const projectData = useSelectedRecommendedProjectSelector();

  return (
    <section className="grid grid-cols-1 gap-6">
      <ClimateRisksCard />
      <ProjectPermanenceCard />
      <NDCTargetsCard country={projectData?.country || "India"} />
    </section>
  );
};

export default RisksTab;
